/**
 * @generated SignedSource<<5141fc0357ccc79589adcbd34196396b>>
 * @relayHash 84e782ffc8e26f54f6c756adad9972bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0ddf0bfc62fba76a1e760da48d27bf54c16c91ed0e78229140c07ce2e6a00746

import type { ConcreteRequest, Query } from 'relay-runtime';
export type StorageHardLimitsModalQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
};
export type StorageHardLimitsModalQuery$data = {
  readonly jira: {
    readonly attachmentStorageAllowed: AGG$Long | null | undefined;
    readonly attachmentStorageUsed: AGG$Long | null | undefined;
  } | null | undefined;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOfferingV2?: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type StorageHardLimitsModalQuery = {
  response: StorageHardLimitsModalQuery$data;
  variables: StorageHardLimitsModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "applicationKey",
    "value": "JIRA_SOFTWARE"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "attachmentStorageAllowed"
    },
    {
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "attachmentStorageUsed"
    }
  ]
},
v3 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "offeringName",
          "value": "Standard"
        },
        {
          "kind": "Literal",
          "name": "skipTrial",
          "value": true
        }
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "experienceUrl"
        },
        {
          "kind": "ScalarField",
          "name": "isAvailableToUser"
        }
      ],
      "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
    }
  ],
  "type": "CcpEntitlementExperienceCapabilities"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StorageHardLimitsModalQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorageHardLimitsModalQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0ddf0bfc62fba76a1e760da48d27bf54c16c91ed0e78229140c07ce2e6a00746",
    "metadata": {},
    "name": "StorageHardLimitsModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d9d187cb10f516cbc1e1bcbc2d4ea111";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
